export function widthAnimation() {
    const $element = $(".has-width-animation .slider-section");
    const $window = $(window); 
    $element.width("47vw");
    $window.on("scroll", function () {
        const $elementTop = $element.offset().top;
        const $windowScroll = $window.scrollTop();
        const $scrollPosition = $windowScroll - $elementTop;
        const viewportWidth = $window.width();
        let width;
        if (viewportWidth >= 768) {
            width = (($scrollPosition / viewportWidth) * 100) + 110;
        }
        if (viewportWidth < 767) {
            width = (($scrollPosition / viewportWidth) * 100) + 210;
        }
        if ($scrollPosition < $element.height() && width > 100) {
            width = 100;
        }
        $element.width(width + "vw");
        $element.slick("setPosition");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/widthAnimation.js